import Vue from 'vue'
import VueRouter from 'vue-router'
import home from '../views/home.vue'
import queryResults from '../views/queryResults.vue'
import report from '../views/report.vue'
import hint from '../views/hint.vue'

Vue.use(VueRouter)

const routes = [
   {
      path: '/',
      name: 'home',
      component: home
   }, {
      path: '/queryResults',
      name: 'queryResults',
      component: queryResults
   }, {
      path: '/report',
      name: 'report',
      component: report
   }, {
      path: '/hint',
      name: 'hint',
      component: hint
   }
]

const router = new VueRouter({
   mode: 'history',
   base: process.env.BASE_URL,
   routes
})

export default router
